<template>
  <button
    ref="target"
    class="flex items-center gap-1 hover:text-gray-500"
    v-bind="$attrs"
    @click="toggleDropdown()"
  >
    <span class="font-bold uppercase">Subscribe</span>
    <Icon name="mdi:email-outline" size="1.1em" />
  </button>
  <Teleport to="#teleports">
    <div
      v-if="open"
      ref="dropdown"
      class="left-0 z-[100] w-full bg-white pb-4 pt-2"
      :style="{ position: strategy, top: `${y}px` }"
    >
      <div class="container">
        <h3 class="mb-2 text-sm font-bold uppercase">
          Be on the list. Stay ahead.
        </h3>
        <NewsletterForm class="md:mr-auto md:w-1/2" @success="onSuccess()" />
      </div>
    </div>
    <div
      v-if="open"
      class="fixed inset-0 z-10 hidden bg-black/40 md:block"
    ></div>
  </Teleport>
</template>

<script setup lang="ts">
import {
  useFloating,
  autoUpdate,
  offset,
  autoPlacement,
} from "@floating-ui/vue"

const target = ref<HTMLElement | null>(null)
const dropdown = ref<HTMLElement | null>(null)

const [open, toggleDropdown] = useToggle(false)

const { y, strategy } = useFloating(target, dropdown, {
  placement: "bottom",
  strategy: "fixed",
  whileElementsMounted: autoUpdate,
  middleware: [offset(10), autoPlacement()],
})

onClickOutside(dropdown, () => {
  open && toggleDropdown(false)
})

const bodyLock = useScrollLock(window, false)

const onSuccess = () => {
  setTimeout(() => {
    toggleDropdown(false)
  }, 3000)
}

watch(open, (value) => {
  bodyLock.value = value
})
</script>
